import { render } from "./TransitionedParagraph.vue?vue&type=template&id=463ef738&scoped=true"
import script from "./TransitionedParagraph.vue?vue&type=script&lang=js"
export * from "./TransitionedParagraph.vue?vue&type=script&lang=js"

import "./TransitionedParagraph.vue?vue&type=style&index=0&id=463ef738&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-463ef738"

export default script